<script>
  import { Vue, Component } from 'vue-property-decorator';
  import _ from 'lodash';

  @Component
  export default class Utils extends Vue {
    get currentUser() {
      return this.$root.user;
    }

    get roleKind() {
      return _.get(this.$root.user, 'role.kind');
    }

    get isTeamLeader() {
      return _.get(this.$root.user, 'is_team_leader');
    }

    get teamMembers() {
      return _.get(this.$root.user, 'team_members', []);
    }

    get teamMemberIds() {
      return this.teamMembers.map((member) => member.id);
    }

    get relatedUserIds() {
      return _.get(this.$root.user, 'related_user_ids', []);
    }

    get performanceGoalTargets() {
      return ['finish_target', 'sales_target', 'shipping_target'];
    }

    get customerOptionsFilter() {
      const result = {};

      if (
        this.roleKind === 'business_executive' ||
        this.roleKind === 'salesman' ||
        this.roleKind === 'merchandiser'
      ) {
        result['user_id_in'] = this.teamMemberIds;
      } else if (this.roleKind === 'customer_service') {
        result['user_id_eq'] = this.currentUser.id;
      } else if (this.roleKind === 'channel_business_executive') {
        result['customer_source_id_in'] = this.currentUser.customer_source_ids;
      }
      return result;
    }

    get userOptionsFilter() {
      let result = {};

      if (['business_executive', 'salesman', 'merchandiser'].includes(this.roleKind)) {
        result['id_in'] = this.teamMemberIds;
      } else if (['customer_service'].includes(this.roleKind)) {
        result['id_in'] = this.relatedUserIds;
      } else if (
        ['application', 'finance_manager', 'channel_business_executive'].includes(
          this.roleKind
        )
      ) {
        result['role_kind_in'] = [
          'salesman',
          'business_executive',
          'channel_business_executive',
          'customer_service',
        ];
      }

      return result;
    }

    get customerSourceOptionsFilter() {
      let result = {};

      if (this.roleKind === 'channel_business_executive') {
        result['id_in'] = this.currentUser.customer_source_ids;
      }

      return result;
    }

    async upload(path, file) {
      const form = new FormData();
      form.append('file_message', file);
      const requestConfig = {
        headers: { 'Content-Type': 'multipart/form-data' },
        responseType: 'blob',
        return_res: true,
        // 1小时超时
        timeout: 1 * 60 * 60 * 1000,
      };
      const result = await this.$request.post(path, form, requestConfig);
      if (result.headers['x-error-message']) {
        throw new Error(decodeURIComponent(result.headers['x-error-message']));
      }
      if (+result.headers['x-error-count'] > 0) {
        this.download(
          new Blob([result.data]),
          `${this.$t('bean.error_massage')}.xlsx`
        );
        throw new Error(this.$t('bean.importFail'));
      }
      let data = JSON.parse(await result.data.text());
      if (data) {
        const successData = data.success.map((item) => ({
          message: item,
          type: '成功',
        }));
        const errorData = data.errors.map((item) => ({
          message: item,
          type: '失败',
        }));
        const columns = [
          { label: '类型', prop: 'type' },
          { label: '信息', prop: 'message' },
        ];
        await this.$msgbox({
          title: '结果',
          customClass: 'import-result-msgbox',
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          confirmButtonText: '关闭',
          message: (
            <div>
              <p>成功：{successData.length}</p>
              {successData.length > 0 && (
                <bean-table
                  size="small"
                  stripe
                  height={null}
                  data={successData}
                  columns={columns}
                />
              )}

              <p>失败：{errorData.length}</p>
              {errorData.length > 0 && (
                <bean-table
                  size="small"
                  stripe
                  height={null}
                  data={errorData}
                  columns={columns}
                />
              )}
            </div>
          ),
        });
      }
    }

    async downloadImportTemplate(path) {
      const result = await this.$request.get(
        path,
        {},
        { responseType: 'blob', return_res: true, timeout: 5 * 60 * 1000 }
      );
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      const blob = new Blob([result.data]);
      a.href = window.URL.createObjectURL(blob);
      a.download = '导入模板.xlsx';
      a.click();
      document.body.removeChild(a);
    }

    // 为了支持导入成功之后刷新页面
    handleImportFileChange(path) {
      return async (e) => {
        const file = e.target.files[0];
        this.importing = true;
        let toastInstance = null;
        if (this.loadingToast) {
          toastInstance = this.$message.info({
            message: this.loadingToast,
            duration: 0,
            showClose: true,
          });
        }
        try {
          await this.upload(path, file);
          await this.$message.success(this.$t('bean.importSuccess'));
          window.location.reload();
        } catch (e) {
          const msg = e.message || this.$t('bean.importFail');
          await this.$message.error(msg);
        } finally {
          this.importing = false;
          if (toastInstance) {
            toastInstance.close();
          }
        }
        e.target.value = '';
      };
    }
  }
</script>
